
	import SwitchBreadCrumb from "@/views/SwitchBreadCrumb.vue";
	import utils from "@/utils";
	import Menu, {
		inEnum,
		MenuIcon,
		numberEnum
	} from "@/model/MenuEnum";
	import {
		Message
	} from "element-ui";
	import triggerMethods from "@/store/triggerMethods";
	import {
		Component,
		Vue,
		Provide,
		Watch
	} from "vue-property-decorator";

	@Component({
		components: {
			SwitchBreadCrumb,
		},
	})
	export default class Container extends Vue {
		$router: any;
		$route: any;
		$refs: any;
		$store: any;

		@Provide() that = this;
		@Provide() isCollapse = false;
		@Provide() username ? : any = "1";
		@Provide() dialogVisible = false;
		@Provide() ruleForm = {
			name: "",
			stateTime: "",
			endTime: "",
			duration: "",
			label: "",
			courseid: "",
			teacherid: "",
			studentid: "",
			types: "",
			classRate: "",
			acduration: "",
			billDuration: "",
			slate: "否",
			sleave: "否",
			fastin: "",
			lastout: "",
		};
		@Provide() rules = {
			name: [{
					required: true,
					message: "请输入课节名称",
					trigger: "blur"
				},
				{
					min: 1,
					max: 60,
					message: "长度在 1 到 60 个字符",
					trigger: "blur"
				},
			],
			stateTime: [{
				required: true,
				message: "请输入预定开始(PEK)",
				trigger: "blur"
			}],
			endTime: [{
				required: true,
				message: "请输入预定结束(PEK)",
				trigger: "blur"
			}],
			duration: [{
				required: true,
				message: "请输入课节时长(分)",
				trigger: "blur"
			}],
			courseid: [{
				required: true,
				message: "请输入学员课程",
				trigger: "blur"
			}],
			studentid: [{
				required: true,
				message: "请输入学生ID",
				trigger: "blur"
			}],
			teacherid: [{
				required: true,
				message: "请输入导师ID",
				trigger: "blur"
			}],
			acduration: [{
				required: true,
				message: "请输入实际上课时长(分)",
				trigger: "blur"
			}],
			slate: [{
				required: true,
				message: "请点击是否迟到",
				trigger: "blur"
			}],
			sleave: [{
				required: true,
				message: "请点击是否早退",
				trigger: "blur"
			}],
			fastin: [{
				required: true,
				message: "请点击第一次进入教室",
				trigger: "blur"
			}],
			lastout: [{
				required: true,
				message: "请点击最后一次离开教室",
				trigger: "blur"
			}],
		};
		@Provide() options2 ? : any = [];
		@Provide() options3 ? : any = [];
		@Provide() filterOptions3 ? : any = [];
		@Provide() gridsearch2 = {
			value: "",
			label: ""
		};
		@Provide() gridsearch3 = {
			value: "",
			label: ""
		};
		@Provide() routeractive = 0;
		@Provide() switchValue = true;
		@Provide() switchFreeValue = false; //赠送课程类型
		@Provide() switchPublicValue = false; //公开课类型
		@Provide() ifSubmit = true; //防止多次触发添加功能
		@Provide() MenuFor = Menu;
		@Provide() MenuIcon = MenuIcon;
		@Provide() ContractReminderInfos: any = [];
		@Provide() PauseStateReminderInfos: any = [];
		@Provide() MonthlyBudgetReminderInfos: any = [];
		@Provide() StudentBirthdayReminderInfos: any = [];
		@Provide() classAppointments: any = {
			count:0,
			underway:[],
			success:[],
			close:[],
			allCount:0,
		};
		@Provide() ifAdmin = false; 
		@Provide() records = []; 
		@Provide() ifShowRecords = false; 
		@Provide() ifAllClass = false; 
		
		
		@Provide() activeName: any ="first";
		
		@Provide() classAppointmentMode = false;
		@Provide() classAppointmentDetail = {teacherTime:{},teacherId:[],classHours:60};
		@Provide() classTeacherList = [];
		@Provide() classAppointmentDetailMode = false;
		@Provide() updClassAppointmentDetailMode = false;
		@Provide() studentShowTime = [];
		@Provide() time = [];
		@Provide() studentTimeMode = false;
		
		@Provide() rejectRemark = "";
		@Provide() rejectMode = false;
		
		@Provide() schoolTime: any = [];
		@Provide() schoolTimeType: any = [];
		@Provide() classType: any = [];
		
		@Provide() showRemarkMode = false;
		@Provide() remarks = [];
		@Provide() auditRemark = null;
		@Provide() timezone = "";
		
		
		



		//监听添加课节时，预定结束如果变动，将更新 实际上课时长(分)
		@Watch("ruleForm.endTime")
		watchEndTime(val: any, oldVal: any): void {
			if (val) {
				const date1: any = new Date(this.ruleForm.stateTime);
				const date2: any = new Date(val);
				if (val != "") {
					//整数
					this.ruleForm.duration = this.ruleForm.acduration = (
						(date2.getTime() - date1.getTime()) /
						60000
					).toFixed(0);
				}
			}
		}
		//监听添加课节时，预定开始如果变动，将更新 实际上课时长(分)
		@Watch("ruleForm.stateTime")
		watchStateTime(val: any, oldVal: any): void {
			if (val) {
				const date1: any = new Date(this.ruleForm.endTime);
				const date2: any = new Date(val);
				if (val != "") {
					this.ruleForm.duration = this.ruleForm.acduration = (
						(date1.getTime() - date2.getTime()) /
						60000
					).toFixed(0);
				}
			}
		}

		//监听实际时长  处理 计费时长
		@Watch("ruleForm.acduration")
		watchAcduration(val: any, oldVal: any): void {
			if (Number(val) >= 0) {
				this.ruleForm.billDuration =
					Number(val) > this.$store.state.dillDurationLimit1 &&
					Number(val) <= this.$store.state.dillDurationLimit2 ?
					this.$store.state.dillDurationLimitValue :
					val;
			}
		}

		//监听公共课类型是否改变
		@Watch("switchPublicValue")
		watchSwitchPublicValue(val: any, oldVal: any): void {
			this.resetSelectCourse()
		}
		
		getDetailTime(time){
			return utils.getDetailTime(time,4);
		}
		
		changeIfAllClass(){
			this.ifAllClass = !this.ifAllClass;
			  this.$nextTick(() => { //在数据加载完，重新渲染表格
			    this.$refs['classAppointments'].doLayout();
			  })
			let detail = {};
			detail.name = utils.getAccountName();
			detail.ifAllClass = this.ifAllClass;
			utils.requestPost("查询约课申请", "MessageAlert/getClassAppointment",detail).then((data: any) => {
				this.classAppointments = this.checkAppointmentData(data);
			});
		}
		
		
		
		getFile(){
			var that = this;
			let fileCount = document.getElementById('topFile').files.length;
			if(fileCount == 0){
				this.$message({
					message: '未选择文件，请重新选择',
					type: "warning",
					duration: 2000
				});
				return;
			}
			let inputFile = document.getElementById('topFile').files[0];
			let formData = new FormData()
			formData.append('file',inputFile)
			utils.requestUploadPost("上传文件", "file/headmasterUpload", formData).then((data) => {
				console.log(data)
				this.$message({
					message: '上传成功，请继续操作',
					type: "success",
					duration: 2000
				});
				this.classAppointmentDetail.file.push({
					name:inputFile.name,
					url:data,
				});
			}).catch((errMsg) => {
				this.$message({
					message: '上传失败，请检查网络连接后，重新上传',
					type: "warning",
					duration: 2000
				});
			});
		}
		
		delFile(index){
			this.classAppointmentDetail.file.splice(index,1);
		}
		choiceImg(index){
			document.getElementById('topFile').click();
		}
		
		checkStudentTime(){
			let time = [];
			for (let i = 0; i < this.time.length; i++) {
			 for (let c = 0; c < this.time[i].length; c++) {
				if(this.time[i][c].checked){
					time.push(this.time[i][c].name);
				}
			 } 
			}
			this.classAppointmentDetail.studentTime = time;
			this.studentShowTime = this.timeGroup(this.classAppointmentDetail.studentTime);
			this.studentTimeMode = false;
		}
		
		addStudentTime(){
			let time = JSON.parse(JSON.stringify(this.time));
			for (let i = 0; i < time.length; i++) {
			 for (let c = 0; c < time[i].length; c++) {
				if(time[i][c].name.length >10 && i == 0){
					let date1 = new Date(time[i][c].name.substring(0,16));
					let date2 = new Date();
					date2.setTime(new Date().getTime()-3600000);
					if(date2.getTime() > date1.getTime()){
						time[i][c].disabled = true;
					}
				} 
				for (let s = 0; s < this.classAppointmentDetail.studentTime.length; s++) {
					if(time[i][c].name == this.classAppointmentDetail.studentTime[s]){
						time[i][c].checked = true;
					}
				} 
			 } 
			}
			this.time = time;
			this.studentTimeMode = true;
		}
		
		showRemarks(remarks,remark){
			this.showRemarkMode = true;
			this.remarks = remarks;
			this.auditRemark = remark;
		}
		
		changeTeacher(detail){
			let list = [];
			for(let c=0;c<this.classAppointmentDetail.teacherId.length;c++){
				let i=0;
				for(i=0;i<this.classTeacherList.length;i++){
					if(this.classTeacherList[i].id == this.classAppointmentDetail.teacherId[c]){
						list.push(this.classTeacherList[i]);
						break;
					}
				}
				if(i == this.classTeacherList.length){
					for(let o=0;o<this.options2.length;o++){
						if(this.options2[o].value == this.classAppointmentDetail.teacherId[c]){
							list.push({
								id:this.options2[o].value,
								name:this.options2[o].label,
								classModelHours:1
							});
							break;
						}
					}
				}
			}
			if(list.length == 0){
				for(let c=0;c<this.classAppointmentDetail.teacherId.length;c++){
					for(let o=0;o<this.options2.length;o++){
						if(this.options2[o].value == this.classAppointmentDetail.teacherId[c]){
							list.push({
								id:this.options2[o].value,
								name:this.options2[o].label,
								classModelHours:1
							});
							break;
						}
					}
				}
			}
			this.classTeacherList = list;
		}
		
		changeRecord(){
			if(this.classAppointmentDetail.record == 0 && this.classAppointmentDetail.recordScene == 0){
				this.classAppointmentDetail.live = 0;
				this.classAppointmentDetail.replay = 0;
			}
			if(this.classAppointmentDetail.live == 0 && this.classAppointmentDetail.replay == 0){
				this.classAppointmentDetail.watchByLogin = 0;
			}
		}
		
		download(item){
			window.open(item.url,'_blank');
		}
		
		checkReject(){
			if(this.rejectRemark.length == 0){
				this.$message({
					message: '请输入原因后再确认',
					type: 'info',
				})
				return;
			}
			this.ifSubmit = false;
			utils.requestPost("班主任拒绝约课申请","MessageAlert/rejectClassAppointment",{
				remark:this.rejectRemark,
				id:this.classAppointmentDetail.id,
				name: utils.getAccountName(),
				ifAllClass:this.ifAllClass,
			}).then((data) => {
				this.$message({
					message: '已拒绝本次约课申请',
					type: "success",
					duration: 2000
				});
				this.rejectMode = false;
				this.classAppointments = this.checkAppointmentData(data);
				this.ifSubmit = true;
			})
		}
		
		checkAppointmentData(data){
			let count = 0;
			let allCount = 0;
			let underway = [];
			let success = [];
			let close = [];
			let timezone = new Date().getTimezoneOffset() / -60;
			this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			for(let i=0;i<data.length;i++){
				let date1 = new Date(data[i].createTime);
				data[i].createTime = utils.getDetailTime(date1.setHours(date1.getHours()+timezone),1);
				if(data[i].state == 1 && data[i].updateTime.indexOf("0001") == -1){
					let lastDate = new Date(date1.setHours(date1.getHours()+72))
				
					var a = parseInt(parseInt(lastDate.getTime() - new Date().getTime()) / 1000);
					 var h = parseInt(a / 3600);
					 var m = parseInt((a % 3600) / 60);
					 var s = ((a % 3600) % 60);
					data[i].hoursTime = h + '小时' + m + '分';
				}
				
				if(data[i].remarks != null)
				data[i].remarks = JSON.parse("["+data[i].remarks+"]");
				if(data[i].teachers != null)
				data[i].teachers = JSON.parse("["+data[i].teachers+"]");
				if(data[i].state == 2 || data[i].state == 3 || data[i].state == 6 ){
					allCount = allCount+1;
					underway.push(data[i]);
				}
				if(data[i].state == 1 || data[i].state == 7){
					count = count+1;
					underway.push(data[i]);
				}
				
				if(data[i].state == 4){
					success.push(data[i]);
				}
				if(data[i].state == 5 || data[i].state == 8){
					close.push(data[i]);
				}
			}
			return {count:count,underway:underway,success:success,close:close,allCount:allCount};
		}
		
		updateClassAppointment(){
			if(this.classAppointmentDetail.studentTime.length == 0){
				this.$message({
					message: '请至少选择一个上课倾向时间',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.classNameIndex == null){
				this.$message({
					message: '请选择课节名称后再继续',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.classNameIndex == 1 &&  (this.classAppointmentDetail.className == null || this.classAppointmentDetail.length == 0)){
				this.$message({
					message: '请输入课节名称后再继续',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.classHours <= 0){
				this.$message({
					message: '请输入预计课节时长后再继续',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.teacherId.length == 0){
				this.$message({
					message: '请分配导师后再继续',
					type: 'info',
				})
				return;
			}
			this.ifSubmit = false;
			let detail = JSON.parse(JSON.stringify(this.classAppointmentDetail));
			detail.file = JSON.stringify(detail.file);
			detail.demandInformation = JSON.stringify(detail.demandInformation).replace(new RegExp("\r\n", "gm"), "brHH");
			let studentTime = detail.studentTime;
			for(let i=0;i<studentTime.length;i++){
				studentTime[i] = utils.getUTCTime(studentTime[i].substring(0,16));
			}
			detail.studentTime = JSON.stringify(studentTime);
			detail.name = utils.getAccountName();
			detail.ifAllClass = this.ifAllClass;
			if(detail.classModel == 1){
				for(let i=0;i<this.classTeacherList.length;i++){
					this.classTeacherList[i].classModelHours = detail.classModelHours;
				}
			}
			detail.teacherList = this.classTeacherList;
			utils.requestPost("修改约课申请", "MessageAlert/updClassAppointment",detail).then((data: any) => {
				this.$message({
					message: '修改约课信息完成',
					type: "success",
					duration: 2000
				});
				this.updClassAppointmentDetailMode = false;
				this.classAppointments = this.checkAppointmentData(data);
				this.ifSubmit = true;
			});
			
		}
		
		agreeingClassAppointment(){
			if(this.classAppointmentDetail.classNameIndex == null){
				this.$message({
					message: '请选择课节名称后再继续',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.classNameIndex == 1 &&  (this.classAppointmentDetail.className == null || this.classAppointmentDetail.length == 0)){
				this.$message({
					message: '请输入课节名称后再继续',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.classNameIndex != 1){
				for(let i=0;i<this.classType.length;i++){
					if(this.classType[i].id == this.classAppointmentDetail.classNameIndex){
						this.classAppointmentDetail.className = this.classType[i].content;
						break;
					}
				}
				
			}
			if(this.classAppointmentDetail.classHours <= 0){
				this.$message({
					message: '请输入预计课节时长后再继续',
					type: 'info',
				})
				return;
			}
			if(this.classAppointmentDetail.teacherId.length == 0){
				this.$message({
					message: '请分配导师后再继续',
					type: 'info',
				})
				return;
			}
			this.ifSubmit = false;
			let detail = JSON.parse(JSON.stringify(this.classAppointmentDetail));
			detail.file = JSON.stringify(detail.file);
			detail.demandInformation = JSON.stringify(detail.demandInformation).replace(new RegExp("\r\n", "gm"), "brHH");
			detail.name = utils.getAccountName();
			if(detail.classModel == 1){
				for(let i=0;i<this.classTeacherList.length;i++){
					this.classTeacherList[i].classModelHours = detail.classModelHours;
				}
			}
			detail.teacherList = this.classTeacherList;
			delete detail.studentTime;
			detail.ifAllClass = this.ifAllClass;
			detail.timezoneNumber = new Date().getTimezoneOffset() / -60;
			utils.requestPost("同意约课申请", "MessageAlert/applyClassAppointment",detail).then((data: any) => {
				this.$message({
					message: '已同意约课申请，等待导师填写可选上课时间',
					type: "success",
					duration: 2000
				});
				this.classAppointmentDetailMode = false;
				this.classAppointments = this.checkAppointmentData(data);
				this.ifSubmit = true;
			});
			
		}
		
		rejectClassAppointment(detail){
			this.classAppointmentDetail = JSON.parse(JSON.stringify(detail));
			this.rejectMode = true;
		}
		
		clearClassAppointment(detail){
			this.$prompt('确认撤销约课吗？如果约课已创建课节，则课节会同步删除。请输入拒绝原因，内容长度限制最大为50。', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  inputPattern: /^(a-z|A-Z|0-9)*[^$%^&*;:,<>?()\""\']{1,50}$/,
			  inputErrorMessage: '请输入拒绝原因，内容长度限制最大为50',
			  type: 'warning'
			}).then((data) => {
				this.ifSubmit = false;
				utils.requestPost("撤销约课", "MessageAlert/clearClassAppointment",{
					id:detail.id,
					state:detail.state,
					auditRemark:data.value
				}).then((data: any) => {
					if(data.error_info.errno == 1 || data.error_info.errno == -1){
						this.$message({
							message: '撤销约课成功',
							type: "success",
							duration: 2000
						});
					}else{
						this.$message({
							message: "撤销失败："+data.error_info.error,
							type: "warning",
							duration: 5000
						});
						this.ifSubmit = true;
					}
					detail.name = utils.getAccountName();
					detail.ifAllClass = this.ifAllClass;
					utils.requestPost("查询约课申请", "MessageAlert/getClassAppointment",detail).then((data: any) => {
						this.classAppointments = this.checkAppointmentData(data);
						this.ifSubmit = true;
					});
				});
			}).catch(() => {         
			});
		}
		
		updClassAppointment(item){
			let schoolTime = [];
			let schoolTimeType = [];
			let classType = [];
			utils.requestGet("查询约课可用信息", "MessageAlert/getClassAppointmentsTypes", null).then((data: any) => {
				for(let i=0;i<data.length;i++){
					
					if(data[i].types == 2){
						schoolTime.push(data[i]);
					}
					if(data[i].types == 3){
						schoolTimeType.push(data[i]);
					}
					if(data[i].types == 4){
						classType.push(data[i]);
					}
					
				}
				this.schoolTime = schoolTime;
				this.schoolTimeType = schoolTimeType;
				this.classType = classType;
				
				let detail = JSON.parse(JSON.stringify(item));
				
				if(detail.file == null){
					detail.file = [];
				}else{
					detail.file = JSON.parse(detail.file);
				}
				
				detail.teacherTime = JSON.parse(detail.teacherTime);
				detail.demandInformation = JSON.parse(detail.demandInformation.replace(/brHH/g, "/r/n"));
				detail.studentTime = JSON.parse(detail.studentTime);
				let studentTime = [];
				for(let i=0;i<detail.studentTime.length;i++){
					studentTime.push(utils.dateToPhase(detail.studentTime[i]));
				}
				
				detail.studentTime = studentTime;
				this.studentShowTime = this.timeGroup(studentTime);
				if(detail.classHours == 0){
					detail.classHours = 60;
				}
				
				this.classAppointmentDetail = detail;
				this.classAppointmentDetail.classModelHours = 120;
				this.classAppointmentDetail.classNameIndex = 1;
				for(let i=0;i<classType.length;i++){
					if(classType[i].content == this.classAppointmentDetail.className){
						this.classAppointmentDetail.classNameIndex = classType[i].id;
					}
				}
				
				if(item.state == 2){
					//查询约课信息下教师
					utils.requestGet("查询约课信息下教师", "teacher/getClassAppointmentsTeachers", {
						id:item.id
					}).then((data: any) => {
						this.classTeacherList = [];
						this.classAppointmentDetail.teacherId = [];
						
						if(data.length != 0){
							this.classAppointmentDetail.classModelHours = data[0].waitingTime;
						}
						
						let classTeacherList = [];
						let teacherId = [];
						for(let i=0;i<data.length;i++){
							teacherId.push(data[i].teacherId+"");
							classTeacherList.push({
								id:data[i].teacherId,
								name:data[i].teacherName,
								classModelHours:data[i].waitingTime
							});
						}
						
						this.classAppointmentDetail.teacherId = teacherId;
						this.classTeacherList = classTeacherList;
						this.updClassAppointmentDetailMode = true;
					});
				}else{
					this.updClassAppointmentDetailMode = true;
				}
				
				
				
			});
			
			//教师信息
			utils.requestGet("查询教师信息", "teacher/select", null).then((data: any) => {
				this.options2 = [];
				for (let i in data) {
					this.gridsearch2 = {
						value: "",
						label: ""
					};
					this.gridsearch2.value = String(data[i].id);
					this.gridsearch2.label += String(data[i].teacherName);
					this.options2 = this.options2.concat(this.gridsearch2);
				}
			});
			
			
			
			
		}
		
		checkClassAppointment(item){
			let schoolTime = [];
			let schoolTimeType = [];
			let classType = [];
			utils.requestGet("查询约课可用信息", "MessageAlert/getClassAppointmentsTypes", null).then((data: any) => {
				for(let i=0;i<data.length;i++){
					
					if(data[i].types == 2){
						schoolTime.push(data[i]);
					}
					if(data[i].types == 3){
						schoolTimeType.push(data[i]);
					}
					if(data[i].types == 4){
						classType.push(data[i]);
					}
					
				}
				this.schoolTime = schoolTime;
				this.schoolTimeType = schoolTimeType;
				this.classType = classType;
				
				
				let detail = JSON.parse(JSON.stringify(item));
				detail.file = JSON.parse(detail.file);
				
				if(detail.teacherTime != null){
					detail.teacherTime = JSON.parse(detail.teacherTime);
					detail.teacherTimes = detail.teacherTime.list;
					for(let i=0;i<detail.teacherTimes.length;i++){
						detail.teacherTimes[i] = utils.dateToPhase(detail.teacherTimes[i]);
					}
					for(let i=0;i<detail.teacherTimes.length;i++){
						let time = new Date(detail.teacherTimes[i]);
						time = new Date(time.setMinutes(time.getMinutes() + 60));
						detail.teacherTimes[i] = (detail.teacherTimes[i])
					}
					detail.teacherTimes = this.timeGroup(detail.teacherTimes);
				}
				
				if("0001-01-01T00:00:00" != detail.classStartTime){
					let timezone = new Date().getTimezoneOffset() / -60;
					detail.classStartTime = utils.getDetailTime(detail.classStartTime,2);
					detail.classStartTime = this.getLocalTime(detail.classStartTime,8);
					detail.classStartTime = this.getLocalTime2(detail.classStartTime,timezone);
					let time = new Date(detail.classStartTime);
					time.setMinutes(time.getMinutes()+detail.classHours);
					detail.classStartTime = detail.classStartTime + " ~ "+utils.getDetailTime(time,2).substring(11,16);
				}
				
				detail.demandInformation = JSON.parse(detail.demandInformation.replace(/brHH/g, "/r/n"));
					detail.studentTime = JSON.parse(detail.studentTime);
						let studentTime = [];
						for(let i=0;i<detail.studentTime.length;i++){
							studentTime.push(utils.dateToPhase(detail.studentTime[i]));
						}
						detail.studentTime = this.timeGroup(studentTime);
				if(detail.classHours == 0){
					detail.classHours = 60;
				}
				
				this.classAppointmentDetail = detail;
				this.classAppointmentDetail.classModelHours = 120;
				if(this.classAppointmentDetail.state == 1 || this.classAppointmentDetail.state == 7){
					this.classAppointmentDetail.classNameIndex = 1;
					for(let i=0;i<classType.length;i++){
						if(classType[i].content == this.classAppointmentDetail.className){
							this.classAppointmentDetail.classNameIndex = classType[i].id;
						}
					}
				}
				
				this.computerTime();
				
				this.classAppointmentDetailMode = true;
			});

			
			//教师信息
			utils.requestGet("查询教师信息", "teacher/select", null).then((data: any) => {
				this.options2 = [];
				for (let i in data) {
					this.gridsearch2 = {
						value: "",
						label: ""
					};
					this.gridsearch2.value = String(data[i].id);
					this.gridsearch2.label += String(data[i].teacherName);
					this.options2 = this.options2.concat(this.gridsearch2);
				}
			});
			
			
		}
		
		getLocalTime(time,i) {
			if(i>0){
				i = 0-i;
			}else{
				i = (i-i-i);
			}
			let d2 = new Date(time);
			let stampGTM = d2.getTime() + (i*60) * 60 * 1000;
			return utils.getDetailTime(stampGTM,2);
		}
		
		getLocalTime2(time,i) {
			let d2 = new Date(time);
			let stampGTM = d2.getTime() + (i*60) * 60 * 1000;
			return utils.getDetailTime(stampGTM,2);
		}
		
		computerTime(){
			if(this.classAppointmentDetail.teachers != null && this.classAppointmentDetail.teachers.length != 0 && this.classAppointmentDetail.state == 2)
			{
				const currentDate = new Date()
				const difference = new Date().getTimezoneOffset() * 60 * 1000;
				const GreenwichMillminutes = new Date().getTime() + difference;
				const GreenwichDate = new Date(GreenwichMillminutes);
				
				let date = new Date(this.classAppointmentDetail.updateTime);
				let number = this.classAppointmentDetail.teachers[0].waitingTime;
				date = date.setHours(number+date.getHours())
				 var a = parseInt(parseInt(new Date(date).getTime()-GreenwichDate.getTime()) / 1000);
				  var h = parseInt(a / 3600);
				  var m = parseInt((a % 3600) / 60);
				  var s = ((a % 3600) % 60);
				  console.log(h + '小时' + m + '分' + s + '秒')
				if(this.classAppointmentDetail.classModel == 1){
					for(let i=0;i<this.classAppointmentDetail.teachers.length;i++){
						this.classAppointmentDetail.teachers[i].waitingDetail = h + '小时' + m + '分';
					}
				}else{
					for(let i=0;i<this.classAppointmentDetail.teachers.length;i++){
						if(i == 0){
							this.classAppointmentDetail.teachers[i].waitingDetail = h + '小时' + m + '分' ;
						}else{
							this.classAppointmentDetail.teachers[i].waitingDetail = this.classAppointmentDetail.teachers[i].waitingTime+"小时";
						}
					}
				}
				
			}
		}
		
		timeGroup(list){
			//日期分组
			let list2 = [];
			let str = list[0];
			let detail = [list[0]];
			for (let i = 1; i < list.length; i++) {
			  if (list[i].substring(0, 10) == str.substring(0, 10)){
				detail.push(list[i]);
			  }else{
				list2.push(detail);
				detail = [list[i]]; 
			  }
			  str = list[i];
			} 
			list2.push(detail);
			//日期计算
			let list3 = [];
			for (let i = 0; i < list2.length; i++) {
				let str = list2[i][0];
				let startTime = list2[i][0];
				for (let c = 1; c < list2[i].length; c++) {
				  if (str.substring(19, 24) == list2[i][c].substring(11, 16)) {
					startTime = startTime.substring(0,19)+list2[i][c].substring(19, 24);
				  }else{
					  list3.push(startTime);
					  startTime = list2[i][c];
				  }
				  str = list2[i][c];
				}
				list3.push(startTime);
			}
			return list3;
		}

		clickFileButton() {
			this.$refs.upload.click();
		}


		uploadLocalImage(e: any) {
			if (e.target.files.length < 1) {
				return;
			}
			if (e.target.files.length > 1) {
				this.$message({
					message: '请单个文件进行上传',
					type: 'info',
				})
				return;
			}
			this.ifSubmit = false;
			let formData = new FormData()
			formData.append('file', e.target.files[0])
			utils.requestUploadPost("上传文件", "file/uploadFile", formData).then((data) => {
				if (data == -2) {
					this.$alert('当前有正在进行中的csv同步，请稍后再进行上传', {
						confirmButtonText: '确定',
						type: "warning",
						callback: action => {}
					});
				}
				if (data == -1) {
					this.$alert('文件格式错误，请检查文件内容或格式是否有误', {
						confirmButtonText: '确定',
						type: "warning",
						callback: action => {}
					});
				}
				if (data == 0) {
					this.$alert('文件中没有需要同步的课节，请检查文件是否有误', {
						confirmButtonText: '确定',
						type: "info",
						callback: action => {}
					});
				}
				if (data > 0) {
					this.$alert('已上传文件，同步工作将在后端进行，待处理课节：' + data + '条，预计同步时间：' + (parseInt(data * 5 / 60) + 1) +
						'~' + (parseInt(data * 10 / 60) + 1) + '分钟，请勿重复上传文件', '上传文件成功', {
							confirmButtonText: '确定',
							type: "success",
							callback: action => {}
						});
				}
				this.$refs.upload.value = null;
				this.ifSubmit = true;
			}).catch((errMsg) => {
				this.$message({
					message: '上传失败，请检查网络连接后，重新上传',
					type: "warning",
					duration: 2000
				});
				this.$refs.upload.value = null;
				this.ifSubmit = true;
			});
		}

		coursetypehandle(flag: Boolean) {
			if (flag) {
				if (this.ruleForm.courseid == "") {
					this.filterOptions3 = this.options3;
				}
				if (!this.switchPublicValue) {
					this.ruleForm.courseid = ""
				}
			}
		}
		//过滤系统
		changeCourseHandle(inputKey: any) {
			this.filterOptions3 = this.options3.filter((item: any): any => {
				return item.label.toLowerCase().includes(inputKey.toLowerCase());
			});

			if (this.switchPublicValue) this.ruleForm.courseid = inputKey;
		}

		//当如果从公开课输入完后又重置为非公开课后进行判断
		resetSelectCourse() {
			if (!this.switchPublicValue) {
				this.ruleForm.courseid = "";
				this.filterOptions3 = this.options3;
			}
		}

		//窗口关闭
		handleCloseadd(): void {
			this.dialogVisible = false;
			this.routeractive = numberEnum(this.$route.path.substring(1), Menu);
		}
		//触发刷新事件
		triggerMethod() {
			triggerMethods.$emit("trigger");
		}

		//Trigger Teacher Methods  get  Access to teacher info
		triggerTeacherMethods(teacherId: any) {
			//Access to teacher info
			utils
				.requestGet("获取教师时薪和货币类型", "teacher/selectType", {
					teacherId: Number(teacherId)
				})
				.then((data: any) => {
					this.ruleForm.classRate = data.teacherRate;
					this.ruleForm.types = data.types === "USD" ? "美元" : "人民币";
				});
		}

		//重置表单信息
		resetForm(formName: any) {
			this.$refs[formName].resetFields();
			this.ruleForm.label = "";
			this.ruleForm.classRate = "";
			this.ruleForm.billDuration = "0";
		}

		//添加课节打开   加载需添加的导师id和课程id
		dialogvisiblemethods(activeIndex: any): void {
			//重定向
			this.routeractive = activeIndex;
			this.dialogVisible = true;

			//教师信息
			utils.requestGet("查询教师信息", "teacher/select", null).then((data: any) => {
				this.options2 = [];
				for (let i in data) {
					this.gridsearch2 = {
						value: "",
						label: ""
					};
					this.gridsearch2.value = String(data[i].id);
					this.gridsearch2.label += String(data[i].teacherName);
					this.options2 = this.options2.concat(this.gridsearch2);
				}
			});

			//课节信息
			utils.requestGet("查询课程信息", "course/select", {
				ifPublic: this.switchPublicValue
			}).then((data: any) => {
				this.options3 = [];
				for (let i in data) {
					this.gridsearch3 = {
						value: "",
						label: ""
					};
					this.gridsearch3.value = String(data[i].id);
					this.gridsearch3.label += String(data[i].courseName);
					this.options3 = this.options3.concat(this.gridsearch3);
				}
			});
		}

		changePublic() {
			//课节信息
			utils.requestGet("查询课程信息", "course/select", {
				ifPublic: this.switchPublicValue
			}).then((data: any) => {
				this.options3 = [];
				for (let i in data) {
					this.gridsearch3 = {
						value: "",
						label: ""
					};
					this.gridsearch3.value = String(data[i].id);
					this.gridsearch3.label += String(data[i].courseName);
					this.options3 = this.options3.concat(this.gridsearch3);
				}
			});
		}

		//提交表单   添加课节信息
		submitForm(ruleForm: any) {
			this.$refs[ruleForm].validate((valid: any) => {
				if (valid) {
					this.ifSubmit = false; //执行添加时   触发按钮  disabled
					let courseName = "";
					let returnFlag = this.options3.find((item: any) => {
						if (item.value === this.ruleForm.courseid)
							courseName = item.label;
						return item.value === this.ruleForm.courseid;
					});
					//判断如果没有在课程中找到该课程，则返回undefined
					if (typeof(returnFlag) == 'undefined') {
						courseName = this.ruleForm.courseid;
						this.ruleForm.courseid = '0';
					}
					//添加
					utils.getUSDRate_time(this.ruleForm.stateTime).then((rate: any) => {
						utils
							.requestPost("添加课节信息", "classes/intoClass", {
								courseName: courseName,
								classRate: Number(this.ruleForm.classRate),
								types: this.ruleForm.types === "美元" ? "USD" : "CNY",
								className: String(this.ruleForm.name),
								classStartName: String(
									typeof utils.getDetailTime(this.ruleForm.stateTime, 5) ==
									"undefined" ?
									"" :
									utils.getDetailTime(this.ruleForm.stateTime, 5)
								),
								classEndName: String(
									typeof utils.getDetailTime(this.ruleForm.endTime, 5) ==
									"undefined" ?
									"" :
									utils.getDetailTime(this.ruleForm.endTime, 5)
								),
								classDuration: Number(this.ruleForm.duration),
								classLable: String(this.ruleForm.label),
								courseId: {
									id: Number(this.ruleForm.courseid)
								},
								teacherId: {
									id: Number(this.ruleForm.teacherid)
								},
								classActualDuration: String(this.ruleForm.acduration),
								classSlate: "",
								classSleave: "",
								classFastln: String(
									typeof utils.getDetailTime(this.ruleForm.stateTime, 5) ==
									"undefined" ?
									"" :
									utils.getDetailTime(this.ruleForm.stateTime, 5)
								),
								classLastout: String(
									typeof utils.getDetailTime(this.ruleForm.endTime, 5) ==
									"undefined" ?
									"" :
									utils.getDetailTime(this.ruleForm.endTime, 5)
								),
								billDuration: String(this.ruleForm.billDuration),
								switchdate: Boolean(this.switchValue),
								rate: rate,
								isFree: this.switchFreeValue,
								isPublic: this.switchPublicValue
							})
							.then((data: any) => {
								if (Number(data) > 0) {
									Message({
										message: "添加成功",
										type: "success",
										duration: 2000,
									});
									this.resetForm("ruleForm"); //表单重置数据
									this.dialogVisible = false; //关闭添加按钮
									this.routeractive = numberEnum(this.$route.path.substring(1),
										Menu); //刷新侧边栏
									this.triggerMethod(); //刷新页面
								} else
									Message({
										message: "添加失败",
										type: "warning",
									});
								this.ifSubmit = true;
							});
					});
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		}

		//注销    退出按钮
		logout() {
			utils.logout();
		}

		//菜单刷新
		reMenu() {
			this.$router.afterEach((to: any, from: any) => {
				if (!to.path.includes("CourseInformationOperation"))
					this.routeractive = numberEnum(to.path.substring(1), Menu);
				else this.routeractive = 0;
			});
		}

		//合同到期提醒功能
		ContractReminderMethods() {
			utils
				.requestGet("合同到期提醒功能", "MessageAlert/ContractReminder", {
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.ContractReminderInfos = data;
				});
		}

		//暂停时间段结束前 推送提醒
		PauseStateReminderMethods() {
			utils
				.requestGet("暂停时间段结束前推送提醒", "MessageAlert/PauseStateReminder", {
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.PauseStateReminderInfos = data.map((item: any) => {
						if (item.dataDiffer == 100) item.dataDiffer = "+ ∞ ";
						if (item.dataDiffer > 0) item.dataDiffer = "+" + item.dataDiffer;
						return item;
					});
				});
		}

		//平均月预算溢出提醒
		MonthlyBudgetReminderMethods() {
			utils
				.requestGet("平均月预算溢出提醒", "MessageAlert/MonthlyBudgetReminder", {
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					//判断 大于115%时进行显示
					if (data.length > 0) {
						data = data.filter((item: any) => item.overflow > 1.15);
					}
					this.MonthlyBudgetReminderInfos = data;
				});
		}

		//学生生日提醒
		StudentBirthdayReminderMethods() {
			utils
				.requestGet("学生生日提醒", "MessageAlert/StudentBirthdayReminder", {
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.StudentBirthdayReminderInfos = data;
				});
		}
		
		getDay(day){
		  var today = new Date();
		  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
		  today.setTime(targetday_milliseconds); //注意，这行是关键代码
		  var tYear = today.getFullYear();
		  var tMonth = today.getMonth();
		  var tDate = today.getDate();
		  tMonth = this.doHandleMonth(tMonth + 1);
		  tDate = this.doHandleMonth(tDate);
		  return tYear + "-" + tMonth + "-" + tDate;
		}
		  doHandleMonth(month) {
		    var m = month;
		    if (month.toString().length == 1) {
		      m = "0" + month;
		    }
		    return m;
		  }

		created(): void {
			
			//获取当前时间，设置为00:00:00
			let nowDate = new Date();
			nowDate.setMinutes(0);
			nowDate.setHours(0);
			nowDate.setSeconds(0);
			let time = [];
			for(let i=0;i<15;i++){
				if(i != 0)nowDate.setDate(nowDate.getDate()+1);
				let list = [{ id: 0, name: utils.getDetailTime(nowDate,4)}];
				for (let d = 0; d < 24; d++) {
					if(d != 0)nowDate.setHours(nowDate.getHours()+1);
					list.push({id: d + "s"+i,
					name: utils.getDetailTime(nowDate,2)+" ~ "+((nowDate.getHours()+1) < 10?"0":"")+(nowDate.getHours()+1)+":00",
					checked:false,disabled: false,});
				}
				nowDate.setHours(0);
				time.push(list);
			}
			this.time = time;

			this.username = localStorage.getItem("username");
			this.routeractive = numberEnum(this.$route.path.substring(1), Menu);

			utils.requestGet("查询需要提醒的消息", "MessageAlert/getMessageReminder", {
				email: utils.getAccountEmail(),
				name: utils.getAccountName(),
			}).then((data: any) => {

				this.ContractReminderInfos = data.contractReminder;

				this.PauseStateReminderInfos = data.pauseStateReminder.map((item: any) => {
					if (item.dataDiffer == 100) item.dataDiffer = "+ ∞ ";
					if (item.dataDiffer > 0) item.dataDiffer = "+" + item.dataDiffer;
					return item;
				});

				//判断 大于115%时进行显示
				if (data.monthlyBudgetReminder.length > 0) {
					data.monthlyBudgetReminder = data.monthlyBudgetReminder.filter((item: any) => item
						.overflow > 1.15);
				}
				this.MonthlyBudgetReminderInfos = data.monthlyBudgetReminder;

				this.StudentBirthdayReminderInfos = data.studentBirthdayReminder;
				
				this.classAppointments = this.checkAppointmentData(data.classAppointments);
				this.ifAdmin = data.ifAdmin;
				
				this.records = data.records;
				
			});
			
		}
	}
